export default __webpack_public_path__ + "static/media/cc_icon.67eb3167.svg";